import { render } from "./friendItem.vue?vue&type=template&id=e541b08e&scoped=true"
import script from "./friendItem.vue?vue&type=script&lang=js"
export * from "./friendItem.vue?vue&type=script&lang=js"

import "./friendItem.vue?vue&type=style&index=0&id=e541b08e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e541b08e"]])

export default __exports__